import React, { Fragment, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { makeStyles } from "@mui/styles";

import PrimaryButton from "../ui/buttons/primaryButton";
import Form from "../ui/forms";
import Checkbox from "../ui/forms/fields/checkbox";
import Select from "../ui/forms/fields/select";
import RadioGroup from "../ui/forms/fields/radioGroup";
import CurrencyInput from "../ui/forms/fields/currencyInput";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";

import {
  NeedToWithdrawListTFSA,
  TaxFreeRiskDescriptionsList,
  TaxFreeRiskProfileTypes,
} from "../../libs/staticData";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  FormControlLabel,
  MenuItem,
  Radio,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Collapse,
  DialogContentText,
  IconButton,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { PlayCircleOutline } from "@mui/icons-material";
import YouTubePlayer from "../ui/youTubePlayer";
import { Box } from "@mui/system";
import {
  fundFilterCalculation,
  fundFilterCalculationTFSA,
} from "../../libs/calculations";
import { useSelector, useDispatch } from "react-redux";
import PDFView from "./pdfView";
import ContactConsultant from "./contactConsuktant";
import { ErrorMessage } from "@hookform/error-message";
import CloseIcon from "@mui/icons-material/Close";
import {
  completeStep,
  resetSteps,
  updateStep,
} from "../../features/stepper.slice";
import {
  getSubmition,
  resetSubmition,
  saveSubmition,
  updateSubmition,
} from "../../features/submition/submition.slice";
import { resetData, updateData } from "../../features/data/data.slice";
import { useGA4React } from "ga-4-react";
import { useNavigate } from "react-router-dom";
import { checkObject, numberToCurrency } from "../../libs/helpers";
import { resetUser } from "../../features/user/user.slice";
import { updateFormStepperSteps } from "../../features/formStepper.slice";
import { Report } from "../../libs/loggers";

const useStyles = makeStyles((theme) => ({}));

const Row = (props) => {
  const { fund, amounts, isSelected } = props;
  const [selected, setSelected] = useState(false);
  const classes = useStyles();

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));

  const validationSchema = yup.object().shape(
    {
      selected: yup.bool(),
      lumpsum: yup.number().when("monthly", {
        is: (monthly) => !monthly || monthly === 0,
        then: yup
          .number()
          .required("Either a Lump Sum or a Monthly Contribution is required")
          .moreThan(
            (fund.minInvestment
              ? fund.minInvestment
              : props.minimums?.lumpsum) - 1,
            `Lumpsum must be more than R ${
              fund.minInvestment ? fund.minInvestment : props.minimums?.lumpsum
            } once off`
          )
          .typeError("Lump Sum must be a number"),
        otherwise: yup
          .number()
          .typeError("Lump Sum must be a number")
          .when("lumpsum", {
            is: (lumpsum) => lumpsum > 0,
            then: yup.number().typeError("Lump Sum must be a number"),
          }),
      }),
      monthly: yup.number().when("lumpsum", {
        is: (lumpsum) => !lumpsum || lumpsum === 0,
        then: yup
          .number()
          .required("Either a Lump Sum or a Monthly Contribution is required")
          .typeError("Monthly Contribution must be a number")
          .moreThan(
            props.minimums?.monthly - 1,
            `Monthly Contribution must be more than R ${props.minimums?.monthly} p/m`
          )
          .when("monthly", (monthly, schema) => {
            return props.minimums?.monthlyMax !== null &&
              props.minimums?.monthlyMax !== undefined
              ? schema.lessThan(
                  props.minimums?.monthlyMax + 1,
                  `Monthly Contribution must be less than ${numberToCurrency(
                    props.minimums?.monthlyMax,
                    0
                  )} p/m`
                )
              : schema;
          }),
        otherwise: yup
          .number()
          .typeError("Monthly Contribution must be a number")
          .when("monthly", {
            is: (monthly) => monthly !== 0,
            then: yup
              .number()
              .typeError("Monthly Contribution must be a number")
              .moreThan(
                props.minimums?.monthly - 1,
                `Monthly Contribution must be more than R ${props.minimums?.monthly} p/m`
              )
              .when("monthly", (monthly, schema) => {
                return props.minimums?.monthlyMax !== null &&
                  props.minimums?.monthlyMax !== undefined
                  ? schema.lessThan(
                      props.minimums?.monthlyMax + 1,
                      `Monthly Contribution must be less than ${numberToCurrency(
                        props.minimums?.monthlyMax,
                        0
                      )} p/m`
                    )
                  : schema;
              }),
          }),
      }),
    },
    ["lumpsum", "monthly"]
  );

  const {
    control,
    handleSubmit,
    watch,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(validationSchema),
  });

  const cbSelectedWatch = watch("selected");
  useEffect(() => {
    onChange();
  }, [cbSelectedWatch]);

  useEffect(() => {
    if (isSelected) {
      setValue("selected", true);
    }
  }, []);

  const onChange = async () => {
    if (await trigger(["selected", "lumpsum", "monthly"]))
      handleSubmit(onSubmit)();
  };

  const onSubmit = (data) => {
    props.onChange(data);
  };

  return (
    <Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        // onClick={(event) => handleClick(event, fund)}
        role="checkbox"
        aria-checked={selected}
        tabIndex={-1}
        selected={selected}
      >
        <TableCell>
          <Checkbox
            name="selected"
            color="primary"
            label=""
            control={control}
            onChange={onChange}
          />
        </TableCell>
        <TableCell padding={"normal"}>
          {fund.name} {fund.code && `(${fund.code})`}
        </TableCell>

        {!mobile && (
          <>
            <TableCell>{fund.time}</TableCell>
            <TableCell>{fund.assetHoldings}</TableCell>
            <TableCell>{fund.regionalHoldings}</TableCell>
          </>
        )}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={watch("selected")} timeout="auto" unmountOnExit>
            <Box
              sx={{ margin: 1, display: "flex" }}
              flexDirection={mobile ? "column" : "row"}
              justifyContent={"space-evenly"}
            >
              <CurrencyInput
                type="number"
                id="lumpsum"
                label="Lump Sum"
                symbol="R"
                error={!!errors.lumpsum}
                helperText={errors?.lumpsum?.message}
                control={control}
                defaultValue={
                  amounts?.lumpsum && amounts.lumpsum > 0 ? amounts.lumpsum : 0
                }
                name="lumpsum"
                className={classes.input}
                onChange={onChange}
              />
              {fund.disableDebitOrder ?? (
                <CurrencyInput
                  control={control}
                  defaultValue={
                    amounts?.debitOrder && amounts.debitOrder > 0
                      ? amounts.debitOrder
                      : 0
                  }
                  name="monthly"
                  className={classes.input}
                  type="number"
                  id="monthly"
                  label="Monthly Contribution"
                  symbol="R"
                  error={!!errors.monthly}
                  helperText={errors?.monthly?.message}
                  onChange={onChange}
                />
              )}
            </Box>{" "}
            {fund.onePager && !mobile ? (
              <PDFView file={fund.onePager} />
            ) : fund.onePager && mobile ? (
              <PrimaryButton href={fund.onePager} target="_blank">
                View more information
              </PrimaryButton>
            ) : null}
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

function HelpTaxFreeSavings(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ga4 = useGA4React();
  const [confirmResetOpen, setConfirmResetOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDisclaimer, setOpenDisclaimer] = useState(false);
  const [openSpeakToConsultant, setOpenSpeakToConsultant] = useState({
    open: false,
  });
  const totalSteps = 4;
  const [player, setPlayer] = useState(false);
  const [selectedFunds, setSelectedFunds] = useState([]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const submitionData = useSelector((state) => state.submition.data);
  const userId = useSelector((state) => state.submition.data?.userId);
  const [withdrawNeedWarning, setWithdrawNeedWarning] = React.useState(false);
  const investVehicles = useSelector(
    (state) => state.investVehicle.value.vehicles
  );
  const [qualifyingFunds, setQualifyingFunds] = useState([]);
  const submitionId = useSelector(
    (state) => state.submition.submition?.submitionId
  );
  let ga4React = useGA4React();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  let page = window.location.pathname.replace(/^\/|\/$/g, "");
  const funds = useSelector((state) =>
    state.investVehicle.value.funds.filter(
      (v) => v.useForTaxFreeInvestmentHelp?.enable
    )
  );
  const vehicle = useSelector((state) => state.data.value.vehicle);

  const stepper = useSelector((state) => state.stepper.value);

  const logEvent = (action, label, category) => {
    ga4.event(action, label, category);
  };

  const validationSchema = yup.object().shape(
    {
      withdrawNeed: yup.string().required("Please select one."),
      riskDesc: yup.string().required("Please select one."),
      riskRelated: yup
        .string()
        .required("Please select the one you relate the most to."),
      riskRelatedScore: yup.number(),
      funds: yup.array().min(1, "Please select at least one fund."),
      acknowledge: yup
        .boolean()
        .default(false)
        .oneOf([true], "Please acknowledge disclaimer to continue."),
    },
    ["lumpsum", "debitOrder"]
  );

  const {
    register,
    handleSubmit,
    control,
    trigger,
    reset,
    watch,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: ["all"],
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (submitionData && submitionData.helpDialog) {
      setActiveStep(submitionData.helpDialog.lastActiveStep);
      setSelectedFunds(submitionData.helpDialog.funds);
      reset(submitionData.helpDialog);
    }
  }, []);

  useEffect(() => {
    register("riskRelatedScore");
    register("funds");
    register("acknowledge");
  }, []);

  useEffect(() => {
    setValue("funds", selectedFunds, { shouldValidate: true });
  }, [selectedFunds, setValue]);

  const watchScore = Math.round(watch("riskRelatedScore") * 100) / 100;
  useEffect(() => {
    setQualifyingFunds(
      funds.filter((f) => {
        if (
          f.useForTaxFreeInvestmentHelp.minPoints <= watchScore &&
          f.useForTaxFreeInvestmentHelp.maxPoints >= watchScore
        ) {
          return f;
        }
      })
    );
  }, [watchScore]);

  const withdrawNeed = watch("withdrawNeed");
  useEffect(() => {
    const wn = NeedToWithdrawListTFSA.types.find(
      (n) => n.desc === withdrawNeed
    );
    if (wn?.warning) setWithdrawNeedWarning(true);
    else setWithdrawNeedWarning(false);
  }, [withdrawNeed]);

  const calculate = () => {
    let riskValues = {};
    let riskProfileValues = {};

    const currentValues = getValues();

    if (currentValues.riskDesc && currentValues.riskDesc !== "") {
      riskValues.weight = 10;
      riskValues.points = TaxFreeRiskDescriptionsList.types.find(
        (x) => x.desc === currentValues.riskDesc
      ).points;
    }

    if (currentValues.riskRelated && currentValues.riskRelated !== "") {
      riskProfileValues.weight = TaxFreeRiskProfileTypes.weight;
      riskProfileValues.points = TaxFreeRiskProfileTypes.types.find(
        (x) => x.name === currentValues.riskRelated
      ).points;
    }

    if (riskValues.weight && riskProfileValues.weight) {
      const result = fundFilterCalculationTFSA(riskValues, riskProfileValues);

      setValue("riskRelatedScore", result, { shouldValidate: true });
    }
  };

  const handlePlayer = () => {
    setPlayer(true);
  };

  const handleClosePlayer = () => {
    setPlayer(false);
  };

  const isLastStep = () => {
    return activeStep === totalSteps - 1;
  };

  const handleNext = async (validate) => {
    const isValid = await trigger(validate);
    const data = await getValues();
    const submit = isLastStep() ? "submit" : "continue";
    const eventInfo = {
      action: "click",
      category: "guidance",
      description: `clicked ${submit}`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        currentFormStep: activeStep + 1,
        value: `next`,
      },
    };
    if (isLastStep() && isValid) {
      handleDisclaimer();
    } else {
      if (isValid) {
        calculate();
        Report(eventInfo, userId, submitionId);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        props.onHelpNext({ ...data, lastActiveStep: activeStep });
        clearErrors();
      }
    }
  };

  const handleBack = () => {
    const eventInfo = {
      action: "click",
      category: "guidance",
      description: "clicked back",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        currentFormStep: activeStep + 1,
        value: `back`,
      },
    };
    Report(eventInfo, userId, submitionId);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleFundSelect = (data, fund) => {
    let currentFunds = [...selectedFunds];

    const eventInfo = {
      action: "select",
      category: "investment-solution",
      description: "select investment solution",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: "select_investment_solution",
        fund: fund.name,
      },
    };

    Report(eventInfo, userId, submitionId);

    if (!data.selected) {
      const fundIndex = currentFunds.findIndex((f) => f.fund.id === fund.id);
      currentFunds.splice(fundIndex, 1);
    }

    if (data.selected && currentFunds) {
      if (currentFunds.length >= 0) {
        currentFunds[0] = {
          fund,
          lumpsum: data.lumpsum,
          monthly: data.monthly,
        };
      } else {
        currentFunds.push({
          fund,
          lumpsum: data.lumpsum,
          monthly: data.monthly,
        });
      }
    }

    setSelectedFunds(currentFunds);
  };

  const onSubmit = (data) => {
    const eventInfo = {
      action: "submit",
      category: "investment-solution",
      description: "submit investment solution",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: "select_investment_solution",
        funds: data.funds,
      },
    };

    Report(eventInfo, userId, submitionId);
    data.formSlug = "tfsa_invest_help";
    props.onDataSubmit({ ...data, lastActiveStep: activeStep });
    setOpen(false);
  };

  const getAmounts = (fund) => {
    const selectedFund = selectedFunds.find(
      (item) => item.fund.name === fund.name && item.fund.id === fund.id
    );

    const { lumpsum = 0, debitOrder = 0 } = selectedFund || {};

    return { lumpsum, debitOrder };
  };

  const NavButtons = (props) => (
    <Box sx={{ mb: 2 }} display="flex" justifyContent={"flex-end"}>
      <PrimaryButton
        disabled={props.index === 0}
        onClick={handleBack}
        sx={{ mt: 1, mr: 1 }}
      >
        Back
      </PrimaryButton>
      <PrimaryButton
        onClick={() => handleNext(props.validate)}
        sx={{ mt: 1, mr: 1 }}
      >
        {userId ? "Save & Continue" : "Continue"}
      </PrimaryButton>
    </Box>
  );

  const FinalStepButtons = (props) => (
    <Box>
      <Box display="flex" justifyContent={"flex-end"}>
        <Button disabled={props.index === 0} onClick={handleBack}>
          Back
        </Button>
      </Box>
      <Box
        display="flex"
        justifyContent={mobile ? "space-between" : "flex-end"}
        alignItems={"center"}
        flexDirection={"row"}
      >
        <Typography>I am happy with this Investment Solution choice</Typography>
        <PrimaryButton onClick={() => handleNext(props.validate)}>
          {"Submit"}
        </PrimaryButton>
      </Box>
      <Box
        display="flex"
        justifyContent={mobile ? "space-between" : "flex-end"}
        alignItems={"center"}
        flexDirection={"row"}
      >
        <Typography>
          I am still uncertain about my Investment Solution choice
        </Typography>
        <PrimaryButton variant={"outlined"} onClick={handleSpeakToConsultant}>
          Speak to a consultant
        </PrimaryButton>
      </Box>
      <Box display="flex" justifyContent={"flex-end"}>
        <Button onClick={handleStartOver}>Start Over</Button>
      </Box>
    </Box>
  );

  const handleStartOver = () => {
    setConfirmResetOpen(true);
  };

  const handleCloseReset = () => {
    setConfirmResetOpen(false);
  };

  const handleConfirmReset = () => {
    logEvent(
      "reset",
      stepper.steps[stepper.active].name,
      `Step ${stepper.active}`
    );

    navigate(stepper.steps[0].url);
    dispatch(resetSubmition());
    dispatch(resetData());
    dispatch(resetSteps());
    dispatch(resetUser());
    setConfirmResetOpen(false);
  };

  const handleDisclaimer = () => {
    const eventInfo = {
      action: "click",
      category: "guidance-disclaimer",
      description: `clicked close disclaimer`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `close`,
      },
    };
    Report(eventInfo, userId, submitionId);
    setOpenDisclaimer(true);
  };

  const closeDisclaimer = async () => {
    const isValid = await trigger("acknowledge");
    setOpenDisclaimer(false);
  };

  const acknowledgeDisclaimer = () => {
    setValue("acknowledge", true, { shouldValidate: true });
    const eventInfo = {
      action: "click",
      category: "guidance-disclaimer",
      description: `clicked acknowledge disclaimer`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `acknowledge`,
      },
    };
    Report(eventInfo, userId, submitionId);
    handleSubmit(onSubmit)();
    setOpenDisclaimer(false);
  };

  const handleSpeakToConsultant = () => {
    const eventInfo = {
      action: "click",
      category: "help",
      description: `clicked "I would like to speak to a consultant"`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `help_speak_to_a_consultant`,
      },
    };
    const data = getValues();
    data.formSlug = "tfsa_invest_help";
    data.fundOptions = qualifyingFunds;

    Report(eventInfo, userId, submitionId);
    setOpenSpeakToConsultant({ open: true, data });
  };

  const setCloseSpeakToConsultant = () => {
    setOpenSpeakToConsultant({ open: false });
  };

  const closeContactConsultant = () => {
    const eventInfo = {
      action: "cancel",
      category: "help",
      description: `cancelled help speak to a consultant`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `cancel_speak_to_a_consultant`,
      },
    };
    Report(eventInfo, userId, submitionId);
    setOpenSpeakToConsultant({ open: false });
  };

  const handleRedirectToUnitTrust = async () => {
    const data = { vehicle: "Basic Investment" };
    let newSubmition;
    const vehicleIndex = investVehicles.findIndex((object) => {
      return object.name === data.vehicle;
    });
    const choseVehicle = investVehicles[vehicleIndex];
    newSubmition = { ...submitionData };
    newSubmition.vehicle = data.vehicle;
    newSubmition.helpDialog = {};
    if (choseVehicle) {
      dispatch(updateFormStepperSteps(choseVehicle.formSections));
    }
    dispatch(saveSubmition({ ...newSubmition }));
    dispatch(updateData({ ...data }));
    navigate("/investment-solution?vehicle=Basic Investment&requireHelp=true");
  };

  return (
    <Fragment>
      <Form>
        <Stepper activeStep={activeStep} orientation="vertical">
          <Step>
            <StepLabel>Your need to withdraw</StepLabel>
            <StepContent>
              <Typography>
                {
                  "To start benefiting from opening a Tax-Free Savings Account, a long-term investment horizon of at least 5 years is ideal. Would you be able to stay invested throughout a minimum period of 5 years?"
                }
              </Typography>
              <RadioGroup
                control={control}
                aria-label="withdrawNeed"
                name="withdrawNeed"
                error={!!errors?.withdrawNeed}
                helperText={errors?.withdrawNeed?.message}
                xs={{ margin: 1 }}
              >
                {NeedToWithdrawListTFSA.types.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    value={item.desc}
                    control={<Radio />}
                    color="primary"
                    label={item.desc}
                    sx={mobile ? { mt: 1, mb: 1 } : {}}
                  />
                ))}
              </RadioGroup>

              <Box display="flex" justifyContent={"center"} sx={{ p: 3 }}>
                {withdrawNeedWarning ? (
                  <Typography
                    color={"primary"}
                    variant="h4"
                    textAlign={"center"}
                  >
                    {NeedToWithdrawListTFSA.warning}
                  </Typography>
                ) : (
                  <Typography color={"primary"} variant="h4">
                    Great, then a Tax-Free Savings Account is what you’re
                    looking for.
                  </Typography>
                )}
              </Box>

              {!withdrawNeedWarning ? (
                <NavButtons
                  index={0}
                  totalSteps={4}
                  validate={"withdrawNeed"}
                />
              ) : (
                <Box sx={{ mb: 2 }} display="flex" justifyContent={"flex-end"}>
                  <PrimaryButton onClick={handleRedirectToUnitTrust}>
                    GO TO UNIT TRUSTS
                  </PrimaryButton>
                </Box>
              )}
            </StepContent>
          </Step>

          <Step>
            <StepLabel>Risk</StepLabel>
            <StepContent>
              <Typography>RISK EXPLANATION WHEN INVESTING:</Typography>
              <Typography>
                Risk can be defined as the possibility of something not turning
                out the way you would have liked or differently to how you
                previously supposed. The 'risk-return trade-off' means: the
                higher the investment's level of risk, the higher the potential
                return and vice versa. This could mean potentially losing some
                of your initial capital invested, but could also mean greater
                potential for growth (as your investment value can move up or
                down). The degree to how much it fluctuates is dependent on the
                asset classes you invest in. When looking at your investment
                options, it's important to consider how much time you have to
                invest, your unique financial situation and how much risk you're
                willing to take on.
              </Typography>
              <br />
              <Typography>
                When you think of 'risk', what word best describes it for you?
              </Typography>
              <RadioGroup
                control={control}
                aria-label="riskDesc"
                name="riskDesc"
                error={!!errors?.riskDesc}
                helperText={errors?.riskDesc?.message}
                xs={{ margin: 1 }}
              >
                {TaxFreeRiskDescriptionsList.types.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    value={item.desc}
                    control={<Radio />}
                    color="primary"
                    label={item.desc}
                  />
                ))}
              </RadioGroup>
              <NavButtons index={1} totalSteps={4} validate={"riskDesc"} />
            </StepContent>
          </Step>

          <Step>
            <StepLabel>Your Investor Profile</StepLabel>
            <StepContent>
              <Typography>
                Read the descriptions below and tell us who you can relate to
                most?
              </Typography>
              {/* <PrimaryButton
                endIcon={<PlayCircleOutline />}
                onClick={() => handlePlayer()}
              >
                Play Video
              </PrimaryButton> */}
              {/* <YouTubePlayer
                open={player}
                onClose={() => handleClosePlayer()}
                title={"The Five Investment Profile Types"}
                videoId={"M5iVIUmqlx8"}
              /> */}

              <RadioGroup
                control={control}
                aria-label="riskRelated"
                name="riskRelated"
                error={!!errors?.riskRelated}
                helperText={errors?.riskRelated?.message}
                xs={{ margin: 1 }}
              >
                {!mobile ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Withdrawing</TableCell>
                        <TableCell>Total Savings</TableCell>
                        <TableCell>Investment Goal</TableCell>
                        <TableCell>Risk Appetite</TableCell>
                        <TableCell>Portfolio</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.tableBody}>
                      {TaxFreeRiskProfileTypes.types.map((item, key) => (
                        <TableRow key={key}>
                          <TableCell width="200px">
                            <FormControlLabel
                              value={item.name}
                              control={<Radio />}
                              color="primary"
                              label={item.name}
                            />
                          </TableCell>
                          <TableCell>{item.withdrawing}</TableCell>
                          <TableCell>{item.totalSavings}</TableCell>
                          <TableCell>{item.investmentGoal}</TableCell>
                          <TableCell>{item.riskAppetite}</TableCell>
                          <TableCell>{item.portfolio}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  TaxFreeRiskProfileTypes.types.map((item, key) => (
                    <FormControlLabel
                      value={item.name}
                      control={<Radio />}
                      color="primary"
                      label={item.name}
                    />
                  ))
                )}
              </RadioGroup>
              <NavButtons index={2} totalSteps={4} validate={"riskRelated"} />
            </StepContent>
          </Step>

          <Step>
            <StepLabel>Fund Selection</StepLabel>
            <StepContent>
              <Table
                size="small"
                padding={mobile ? "none" : "normal"}
                sx={{ mt: 1, mb: 2 }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="subtitle2">Select</Typography>
                    </TableCell>
                    <TableCell padding={"normal"}>
                      <Typography variant="subtitle2">
                        Investment Solution
                      </Typography>
                    </TableCell>

                    {!mobile && (
                      <>
                        <TableCell>
                          <Typography variant="subtitle2">Time</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="subtitle2">
                            Asset Holdings
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="subtitle2">
                            Regional Holdings
                          </Typography>
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {qualifyingFunds.map((fund, index) => (
                    <Row
                      key={index}
                      fund={fund}
                      onChange={(data) => handleFundSelect(data, fund)}
                      minimums={props.minimums || null}
                      amounts={getAmounts(fund)}
                      isSelected={selectedFunds.some(
                        (item) =>
                          item.fund.name === fund.name &&
                          item.fund.id === fund.id
                      )}
                    />
                  ))}
                </TableBody>
              </Table>

              <Box display="flex" justifyContent="flex-end">
                <ErrorMessage
                  errors={errors}
                  name="acknowledge"
                  render={({ message }) => (
                    <Typography color="error">{message}</Typography>
                  )}
                />
              </Box>
              <Box>
                {isLastStep() && (
                  <ErrorMessage
                    errors={errors}
                    name="funds"
                    render={({ message }) => (
                      <Typography color="error">{message}</Typography>
                    )}
                  />
                )}
              </Box>
              <FinalStepButtons index={3} totalSteps={4} validate={"funds"} />
            </StepContent>
          </Step>
        </Stepper>
      </Form>

      <Dialog open={openDisclaimer} onClose={closeDisclaimer}>
        <DialogTitle>Disclaimer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            I acknowledge that this tool is a factual filter of published
            information relevant to each investment solution's fact sheet. It
            does not make a recommendation or render advice to an investor, but
            merely provides factual information. For advice on the suitability
            of these products to the investor's financial goals and objectives,
            we strongly recommend consulting an approved financial advisor.
            Please note the disclosures relevant to each product displayed on
            this page as published on their fact sheets. Fairtree Asset
            Management is an authorised financial services provider (FSP 25917).
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <PrimaryButton onClick={closeDisclaimer} color="primary">
            Close
          </PrimaryButton>
          <PrimaryButton onClick={acknowledgeDisclaimer} color="primary">
            Acknowledge
          </PrimaryButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmResetOpen}
        onClose={handleCloseReset}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Start Over?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to start over?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseReset}>Cancel</Button>
          <Button onClick={handleConfirmReset} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <ContactConsultant
        title="Speak to a consultant"
        subTitle={""}
        open={openSpeakToConsultant.open}
        data={openSpeakToConsultant.data}
        onClose={closeContactConsultant}
        setCloseSpeakToConsultant={setCloseSpeakToConsultant}
      />
    </Fragment>
  );
}

export default HelpTaxFreeSavings;
